import api from "~/services/apis/antecipeApi";

const BASE = "antecipeadmin/access";

// Tira filtros vazios/false (exceto os listados em keep) para a URL ficar limpa.
const compact = (params, keep = []) =>
  Object.fromEntries(
    Object.entries(params).filter(([key, value]) => {
      if (keep.includes(key)) return true;
      if (value === undefined || value === null || value === false) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    })
  );

// Teto do BE em todas as listas (spec §4.5, P1-5). O FE nunca pede mais que isso; pagina.
export const ACCESS_PAGE_LIMIT = 100;
const capLimit = (limit) => Math.min(Number(limit) || ACCESS_PAGE_LIMIT, ACCESS_PAGE_LIMIT);

export const listAccessUsers = async ({ search, externalOnly, pendingOnly, hideDisabled = true, limit = ACCESS_PAGE_LIMIT, offset = 0 } = {}, { signal } = {}) => {
  const params = compact({ search: search?.trim(), externalOnly, pendingOnly, hideDisabled, limit: capLimit(limit), offset }, ["hideDisabled"]);
  const response = await api.get(`${BASE}/users`, { params, signal });
  return {
    total: Number(response.data.total_items) || 0,
    users: response.data.data,
    companies: response.data.companies || [],
    activeAdminsCount: Number(response.data.activeAdminsCount) || 0,
  };
};

// Todas as páginas (só para "Exportar matriz"). Para quando uma página vem incompleta.
export const listAllAccessUsers = async (filters = {}, { signal } = {}) => {
  let offset = 0;
  let first = null;
  const users = [];
  for (;;) {
    // eslint-disable-next-line no-await-in-loop
    const result = await listAccessUsers({ ...filters, limit: ACCESS_PAGE_LIMIT, offset }, { signal });
    first = first || result;
    users.push(...result.users);
    offset += ACCESS_PAGE_LIMIT;
    if (result.users.length < ACCESS_PAGE_LIMIT || users.length >= result.total) break;
  }
  return { ...first, users };
};

export const getAccessUser = async (id) => (await api.get(`${BASE}/users/${id}`)).data.data;

// PUT access/users/:id/grants (BE-0g): `grants` é a lista completa desejada. Devolve também o users.updated_at
// novo, que a ficha precisa para o próximo POST access/changes (senão STALE_ACCESS falso).
export const setUserGrants = async (id, grants) => {
  const { data } = (await api.put(`${BASE}/users/${id}/grants`, { grants })).data;
  return { grants: data.grants, updatedAt: data.updatedAt };
};

export const applyAccessChanges = async (changes) => (await api.post(`${BASE}/changes`, { changes })).data.data.applied;

export const deactivateUser = async (id) => (await api.post(`${BASE}/users/${id}/deactivate`)).data.data;
export const reactivateUser = async (id) => (await api.post(`${BASE}/users/${id}/reactivate`)).data.data;

export const createInvite = async (body) => (await api.post(`${BASE}/invites`, body)).data.data;
export const resendInvite = async (inviteId) => (await api.post(`${BASE}/invites/${inviteId}/resend`)).data.data;
export const getInviteLink = async (inviteId) => (await api.post(`${BASE}/invites/${inviteId}/link`)).data.data;
export const revokeInvite = async (inviteId) => (await api.post(`${BASE}/invites/${inviteId}/revoke`)).data?.data;

// 409 INVITE_ALREADY_PENDING { inviteId, status: 'pending'|'expired', expiresAt } (spec §6.2, P1-4).
export const pendingInviteFromError = (error) => {
  const data = error?.response?.data;
  if (error?.response?.status !== 409 || data?.code !== "INVITE_ALREADY_PENDING" || !data.inviteId) return null;
  return { inviteId: data.inviteId, status: data.status, expiresAt: data.expiresAt };
};

export const listDenials = async (params, { signal } = {}) => {
  const response = await api.get(`${BASE}/denials`, { params: compact({ ...params, limit: capLimit(params.limit) }), signal });
  return { total: Number(response.data.total_items) || 0, rows: response.data.data };
};

export const listAudit = async (params, { signal } = {}) => {
  const response = await api.get(`${BASE}/audit`, { params: compact({ ...params, limit: capLimit(params.limit) }), signal });
  return { total: Number(response.data.total_items) || 0, rows: response.data.data };
};
